<form>
  <div class="widget">
    <div class="widget-header">
      <h4>{{ 'ACCOUNTING' | translate }}</h4>
    </div>
    <div class="widget-content">
      <div>
        <div class="form-group">
          <div class="col-md-3">
            <b>{{ 'SHOWING_ACCOUNTING_FROM_PRODUCT_CATEGORY' | translate }}</b>
            <div class="text-muted">
              {{ 'SHOWING_ACCOUNTING_FROM_PRODUCT_CATEGORY_MSG' | translate }}
            </div>
          </div>
          <div class="col-md-9">
            <mat-slide-toggle
              class="example-margin"
              [color]="'primary'"
              [checked]="slideChecked"
              (toggleChange)="slideChange()"
            >
              <span *ngIf="slideChecked">{{ 'YES' | translate }}</span>
              <span *ngIf="!slideChecked">{{ 'NO' | translate }}</span>
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div *ngIf="loadingData" class="text-center modal-body">
          <span class="loading-spiner spinner-form-left"></span>
        </div>
        <br />
        <div *ngIf="product && !loadingData">
          <br />
          <div class="col-md-12 form-group">
            <label class="col-md-4 control-label align-right">
              {{ 'INCOME_ACCOUNT' | translate }}
            </label>
            <div class="col-md-7">
              <p *ngIf="!slideChecked" class="form-label">
                {{ incomeAccountControl.value || '-' }}
              </p>
              <div *ngIf="slideChecked">
                <input
                  type="text"
                  class="select form-control"
                  placeholder="{{ 'SELECT' | translate }} ..."
                  matInput
                  [formControl]="incomeAccountControl"
                  [matAutocomplete]="autoIncome"
                />
                <mat-autocomplete autoActiveFirstOption #autoIncome="matAutocomplete">
                  <mat-option
                    *ngFor="let option of filteredIncomeAccounts | async"
                    [value]="option.code + ' ' + option.name"
                    (onSelectionChange)="incomeSelected(option.id)"
                  >
                    {{ option.code }} {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label class="col-md-4 control-label align-right">
              {{ 'EXPENSE_ACCOUNT' | translate }}
            </label>
            <div class="col-md-7">
              <p *ngIf="!slideChecked" class="form-label">
                {{ expenseAccountControl.value || '-' }}
              </p>
              <div *ngIf="slideChecked">
                <input
                  type="text"
                  class="select form-control"
                  placeholder="{{ 'SELECT' | translate }} ..."
                  matInput
                  [formControl]="expenseAccountControl"
                  [matAutocomplete]="autoExpense"
                />
                <mat-autocomplete autoActiveFirstOption #autoExpense="matAutocomplete">
                  <mat-option
                    *ngFor="let option of filteredExpenseAccounts | async"
                    [value]="option.code + ' ' + option.name"
                    (onSelectionChange)="expenseSelected(option.id)"
                  >
                    {{ option.code }} {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <br />
            <div *ngIf="slideChecked" class="form-actions no-wrap">
              <span *ngIf="sendingChartAccounts" class="loading-spiner spinner-form-left"></span>

              <!-- Apply-->
              <button
                type="button"
                class="btn btn-lg btn-primary"
                [disabled]="sendingChartAccounts || invalidChartAccounts"
                (click)="applyChartAccounts(product)"
              >
                <i class="fa fa-save"></i> {{ 'APPLY_CHANGES' | translate }}
              </button>
              <!-- Cancel -->
              <button type="button" class="btn btn-lg" (click)="cancelChartAccounts()">
                <i class="fa fa-undo"></i> {{ 'CANCEL' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
